<div class="relative w-full">
  <label *ngIf="label" class="block text-[#242729] font-light text-sm">{{ label }}</label>
  <input
    [type]="type"
    [name]="name"
    [autocomplete]="autocomplete"
    [placeholder]="placeholder"
    class="mt-1 w-full bg-white rounded-md text-gray-800 placeholder:text-gray-300 border border-solid focus:border-yellow-800 hover:border-gray-800 disabled:border-gray-300 focus:border-[1.5px] hover:border-[1.5px] focus:-m-[0.5px] hover:-m-[0.5px] focus:mt-[3.5px] hover:mt-[3.5px] disabled:border outline-none p-2 text-sm"
    [(ngModel)]="value"
    [required]="true"
    (blur)="onBlur()"
    [ngClass]="{
      'border-bey-red': displayError,
      'border-gray-800': !displayError
    }"
    inputmode="numeric"
    pattern="[0-9]*"
    aria-autocomplete="list" />
  <bey-field-error-message *ngIf="!hideValidationFeedback" [displayError]="displayError" [errorMessage]="errorMessage">
  </bey-field-error-message>
  <svg
    *ngIf="type === 'password'"
    class="eye"
    (click)="onEyeClick(true)"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8407 9.8971C15.5644 12.8721 12.5741 14.7411 9.34067 14.5846C6.42736 14.264 3.93229 12.3539 2.86255 9.62523C3.96734 6.9568 6.45616 5.11724 9.3313 4.84398C12.6574 4.74953 15.6754 6.78041 16.8407 9.8971Z"
      stroke="#80807D"
      stroke-width="1.5"
      stroke-linecap="round" />
    <path
      d="M9.8564 11.6971C10.9541 11.6971 11.8439 10.8073 11.8439 9.70961C11.8439 8.61194 10.9541 7.72211 9.8564 7.72211C8.75873 7.72211 7.8689 8.61194 7.8689 9.70961C7.8689 10.8073 8.75873 11.6971 9.8564 11.6971Z"
      stroke="#80807D"
      stroke-width="1.5"
      stroke-linecap="round" />
  </svg>

  <svg
    *ngIf="type !== 'password'"
    class="eye"
    (click)="onEyeClick(false)"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.9813 14.1469C12.613 15.1006 10.9567 15.5511 9.2938 15.4219C6.40687 15.0917 3.93555 13.2004 2.86255 10.5C3.5902 8.85345 4.82974 7.48568 6.39692 6.59998"
      stroke="#80807D"
      stroke-width="1.5"
      stroke-linecap="round" />
    <path
      d="M9.3313 5.73753C12.6492 5.6443 15.6609 7.66593 16.8313 10.7719C16.5311 11.4533 16.1297 12.0854 15.6407 12.6469"
      stroke="#80807D"
      stroke-width="1.5"
      stroke-linecap="round" />
    <path
      d="M11.6376 11.5875C11.2668 12.0906 10.6783 12.3866 10.0533 12.3844C9.22925 12.3889 8.48874 11.8821 8.1946 11.1123C7.90047 10.3426 8.11433 9.47113 8.73139 8.92499"
      stroke="#80807D"
      stroke-width="1.5"
      stroke-linecap="round" />
    <path d="M3.3313 3.1875L16.0157 15.8719" stroke="#80807D" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</div>
